import React from 'react'
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    FbButton,
    Icons,
    GridContainer,
    GridItem,
    Typography,
} from '@fabricks/ui-components'
import { useKeycloak } from 'react-keycloak'
import {
    useCalculateCurrentFuelLevelsMutation,
    useCalculateEfficiencyNumberMutation, useResetTenantMutation,
} from '../../api/models'
import DebugContainer from '../../components/Debug/debug'
import Swal from "sweetalert2";
import axios from "axios";
import getEnvVars from "../../environment/environment";
import { downloadFile } from "../../utils/apiUtils";
import { handleResponseWithSwal } from "../../utils/apiUtils";

interface DeveloperModeProps {
}

export const DeveloperMode: React.FC<DeveloperModeProps> = (props: DeveloperModeProps) => {
    const [keycloak] = useKeycloak()
    const [executeCalc, calcResult] = useCalculateEfficiencyNumberMutation()
    const [executeCalculateCurrentFuelLevels, executeCalculateCurrentFuelLevelsResult] = useCalculateCurrentFuelLevelsMutation()
    const [executeTenantResetRequest, executeTenantResetResult] = useResetTenantMutation()

    const executeEfficiencyNumberCalculation = () => {
        executeCalc({
            context: { headers: { Authorization: `Bearer ${keycloak.token || 'unknown'}` } },
            variables: {},
        }).then(() => handleResponseWithSwal('calculateEfficiencyNumber'))
    }

    const executeFielLevelCalculation = () => {
        executeCalculateCurrentFuelLevels({
            context: { headers: { Authorization: `Bearer ${keycloak.token || 'unknown'}` } },
            variables: {},
        }).then(() => handleResponseWithSwal('calculateCurrentFuelLevels'))
    }

    const executeTenantReset = () => {
        executeTenantResetRequest({
            context: { headers: { Authorization: `Bearer ${keycloak.token || 'unknown'}` } },
            variables: {},
        }).then(() => handleResponseWithSwal('resetTenant'))
    }

    const renderDownload = () => {
        const handleDownload = () => {
            Swal.fire({
                title: `Download`,
                text: 'The warehouse data will be prepared. This takes some time',
                showLoaderOnConfirm: true,
                icon: 'success',
                confirmButtonText: 'Download',
                preConfirm: () => {
                    return axios
                        .get(`${getEnvVars.bff.host}/storage-structure`, {
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                Authorization: keycloak.token ? `Bearer ${keycloak.token}` : '',
                            },
                            responseType: 'blob',
                        })
                        .then(downloadFile)
                },
            })
        }
        return (<FbButton variant="contained" color="primary" onClick={handleDownload} fullWidth={true}>
            <Icons.GetApp opacity={1} /> Download storage structure
        </FbButton>)
    }

    return (
        <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
                <Card className="card graph">
                    <CardHeader color="primary" isStats={false} type="plain">
                        <CardTitle color="white" align="center" title="Control panel" variant="h5" />
                    </CardHeader>
                    <CardBody align="center" isProfile>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12 }>
                                <FbButton variant="contained" color="primary" fullWidth={true}
                                          onClick={executeTenantReset}>
                                    Reset tenant
                                </FbButton>
                                <br/>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12 }>
                                <FbButton variant="contained" color="primary" fullWidth={true}
                                          onClick={executeEfficiencyNumberCalculation}>
                                    Execute  Efficiency Calculation
                                </FbButton>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <FbButton variant="contained" color="primary" fullWidth={true}
                                          onClick={executeFielLevelCalculation}>
                                    Execute box type preprocessing
                                </FbButton>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                { renderDownload() }
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
                <Card className="card graph">
                    <CardHeader color="primary" isStats={false} type="plain">
                        <CardTitle color="white" align="center" title="Used Bearer Token" variant="h5" />
                    </CardHeader>
                    <CardBody align="center" isProfile>
                        <DebugContainer>{JSON.stringify({ token: `Bearer ${keycloak.token}` })}</DebugContainer>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    )
}

export default DeveloperMode
